/**
 * Wettersymbol (F-39) - Lucide statt Emoji, damit es auf jedem Geraet
 * gleich aussieht und die Textfarbe der Umgebung uebernimmt (Leitlinie 7).
 * Die Bedeutung steht immer als Text daneben bzw. im Tooltip - das Symbol
 * selbst ist deshalb fuer Screenreader ausgeblendet.
 */
import {
  Cloud, CloudDrizzle, CloudFog, CloudLightning, CloudRain, CloudSnow, CloudSun, CloudSunRain, Snowflake, Sun,
  type LucideIcon,
} from 'lucide-react';

import { describeWeather, type WetterSymbolName } from '@/lib/weather/model';
import { cn } from '@/lib/utils/cn';

const SYMBOLE: Record<WetterSymbolName, LucideIcon> = {
  klar: Sun,
  sonnig: CloudSun,
  bedeckt: Cloud,
  nebel: CloudFog,
  niesel: CloudDrizzle,
  regen: CloudRain,
  schnee: CloudSnow,
  schauer: CloudSunRain,
  schneeschauer: Snowflake,
  gewitter: CloudLightning,
};

export function WetterSymbol({ code, className }: { code: number; className?: string }) {
  const Symbol = SYMBOLE[describeWeather(code).symbol];
  return <Symbol aria-hidden="true" className={cn('inline-block shrink-0', className)} />;
}
